// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success-update-creditcard-info[data-v-027e540e]{text-align:center;margin-top:3rem;margin-bottom:3rem}.update-creditcard-form[data-v-027e540e]{margin-top:3rem}.heading[data-v-027e540e]{display:flex;flex-direction:row;justify-content:center;align-items:center;gap:8px;font-weight:700;font-size:14px;line-height:150%}.heading-icon[data-v-027e540e]{width:16px;height:16px;border-radius:8px;background-color:#404040}", ""]);
// Exports
module.exports = exports;
